import { Component } from 'react';
import AddNewProjectModal from '../create/addNewProjectModal';
import { createProjects } from '../create/query';
import ProjectEditModal from './modal/EditProject/modal';

class AdditionalBox extends Component {
    constructor() {
        super();

        this.openAddNewProjectModal = this.openAddNewProjectModal.bind(this);
        this.closeAddNewProjectModal = this.closeAddNewProjectModal.bind(this);
        this.onAddProject = this.onAddProject.bind(this);
        this.handleOpenEvent = this.handleOpenEvent.bind(this);

        this.state = {
            isOpenAddNeProjectModal: false,
            addProjectLoading: false,
        };
    }

    handleOpenEvent() {
        this.openAddNewProjectModal();
    }

    componentDidMount() {
        document.addEventListener('ai_tracking_create_new_project', this.handleOpenEvent);
    }

    componentWillUnmount() {
        document.removeEventListener('ai_tracking_create_new_project', this.handleOpenEvent);
    }

    openAddNewProjectModal() {
        this.setState({
            isOpenAddNeProjectModal: true,
        });
    }
    closeAddNewProjectModal() {
        this.setState({
            isOpenAddNeProjectModal: false,
        });
    }

    async onAddProject(name) {
        try {
            this.setState({
                addProjectLoading: true,
            });

            const body = {
                name,
                is_default: false,
            };

            await createProjects(body);
            this.props.getProjectsData();
            this.setState({
                addProjectLoading: false,
                isOpenAddNeProjectModal: false,
            });
        } catch (err) {
            this.setState({
                addProjectLoading: false,
                message: err?.message ?? 'Something went wrong.',
            });
        }
    }

    render() {
        return (
            <>
                {this.state.isOpenAddNeProjectModal && (
                    <ProjectEditModal
                        isOpen={this.state.isOpenAddNeProjectModal}
                        onClose={this.closeAddNewProjectModal}
                        isCreate
                        updateData={this.props.getProjectsData}
                    />
                )}
            </>
        );
    }
}

export default AdditionalBox;
